exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gallery-alert__container[data-v-2ba629a2]{margin-top:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ba629a2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["D://BuildAgent2//work//190b1d2d9f9a26c6//Commerce//Commerce.Web//node_modules//bootstrap-sass//assets//stylesheets//bootstrap//_variables.scss","D://BuildAgent2//work//190b1d2d9f9a26c6//Commerce//Commerce.Web//WebResources//scss//shared//_global-variables.scss","D://BuildAgent2//work//190b1d2d9f9a26c6//Commerce//Commerce.Web//WebResources//scss//shared//environment-variables//production.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WebResources/vue/proofs/index/components/PreOrderSearchEmail/PreOrderSearchEmail.vue
// module id = 746
// module chunks = 1